/* global fetch */
import { useSelector } from 'react-redux'
import { URLS } from '../../const/nav'
import { authFetch } from '../../services/authFetch'

export const useInform = () => {
  const { user } = useSelector(state => state)

  const parseResponse = async (response, actionName) => {
    let parsedBody = null

    try {
      parsedBody = await response.json()
    } catch (error) {}

    if (!response.ok) {
      const backendMessage = parsedBody && (parsedBody.detalle || parsedBody.mensaje)
      throw new Error(`${actionName} falló (${response.status}): ${backendMessage || response.statusText}`)
    }

    return parsedBody
  }

  const cancelReport = async () => {
    const response = await authFetch(`${URLS.BACKEND_URL}/informes/cancelar`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${user.token}`
      }
    })

    return parseResponse(response, 'Cancelar informe')
  }

  const uploadReport = async () => {
    const response = await authFetch(`${URLS.BACKEND_URL}/informes/subir`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${user.token}`
      }
    })

    return parseResponse(response, 'Subir informe')
  }

  const updateInform = async (inform) => {
    const response = await authFetch(`${URLS.BACKEND_URL}/informes/guardar`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${user.token}`
      },
      body: JSON.stringify(inform)
    })

    return parseResponse(response, 'Guardar informe')
  }

  return { cancelReport, uploadReport, updateInform }
}
